"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySystemRootKeyMutator = void 0;
const Item_1 = require("../../Abstract/Item");
class KeySystemRootKeyMutator extends Item_1.DecryptedItemMutator {
}
exports.KeySystemRootKeyMutator = KeySystemRootKeyMutator;
